import { render, staticRenderFns } from "./CollectionCustomer.vue?vue&type=template&id=3c3ee71f&scoped=true"
import script from "./CollectionCustomer.vue?vue&type=script&lang=js"
export * from "./CollectionCustomer.vue?vue&type=script&lang=js"
import style0 from "./CollectionCustomer.vue?vue&type=style&index=0&id=3c3ee71f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ee71f",
  null
  
)

export default component.exports